import { render, staticRenderFns } from "./Digisign.vue?vue&type=template&id=6bebe246&scoped=true&"
import script from "./Digisign.vue?vue&type=script&lang=ts&"
export * from "./Digisign.vue?vue&type=script&lang=ts&"
import style0 from "./Digisign.vue?vue&type=style&index=0&id=6bebe246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebe246",
  null
  
)

export default component.exports